import { translationsEn } from '@spartacus/assets';
import { I18nConfig } from '@spartacus/core';
import { AtgTranslationChunksConfig, AtgTranslations } from './atg-translations';

export function AtgTranslationFactory(): I18nConfig {
  return {
    i18n: {
      chunks: AtgTranslationChunksConfig,
      resources: {
        en: {
          ...translationsEn,
          ...AtgTranslations['en'],
        },
        fr_CA: {
          ...translationsEn,
          ...AtgTranslations['fr_CA'],
        },        
      },
    },
  };
}
